/**
 * Dumb renderer for the "too small" area restriction warning.
 */

import React from "react";
import Typography from "@mui/material/Typography";
import WarningIcon from "@mui/icons-material/Warning";

export default function TooSmallWarning({ visible, text }) {
  if (!visible) return null;

  return (
    <Typography style={{ fontSize: "small", marginTop: 8 }}>
      <WarningIcon
        style={{ color: "orange", verticalAlign: "bottom" }}
        fontSize="small"
      />
      <small>{text}</small>
    </Typography>
  );
}
